import { render, staticRenderFns } from "./cartItemDetail.vue?vue&type=template&id=10a9ee29&scoped=true"
import script from "./cartItemDetail.vue?vue&type=script&lang=js"
export * from "./cartItemDetail.vue?vue&type=script&lang=js"
import style0 from "./cartItemDetail.vue?vue&type=style&index=0&id=10a9ee29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9ee29",
  null
  
)

export default component.exports